import { HEADSHOT_GENERATOR_UPLOAD_FILE_TYPE, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData';
import { DYNAMIC_STEPS_CONFIG, GENDER_OPTIONS, RATIO_OPTIONS } from '../../config/dataConfig/FJHeadshotGeneratorData';
import FJConfig from '../../config/FJConfig';
import FJS3Config from '../../config/FJS3Config';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJHeadshotUtil from '../../util/FJHeadshotUtil';
import FJUtil from '../../util/FJUtil';
import { setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    setCurrentHeadshotStatus,
    resetHeadshotGeneratorState,
    setCurrentStepIndex,
    setSelectedCategory,
    setSelectedCategoryKey,
    setSelectedGender,
    setSelectedProfession,
    setSelectedHairPreferences,
    setSelectedClothingPreference,
    setSelectedBackgroundPreference,
    setSelectedTheme,
    setSelectedRatio,
    setSelectedShot,
    setMaxSteps,
    setImageInfo,
    setTabIndex,
    setCurrentCollection,
    setImageUploadStatus,
    setTotalOutput,
    setGeneratingHeadshotNum,
    setIsShowGeneratingHeadshotNum,
    setHeadshotPromptDataSet,
    setCurrentTaskId,
    setHairColorNewOption,
    setOriginImage,
    setSelectedAge,
} from '../slices/FJSliceHeadshotGenerator';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';

let f_headshot_timer = null;
let f_headshot_isPolling = false;
let f_headshot_errorTime = 0;
let f_headshot_isUploading = false;
const MAX_POLLING_ERROR_TIME = 10;
// const MAX_IMAGE_SIZE = 5; // 5MB
const MIN_IMAGE_SIZE = {
    minWidth: 200,
    minHeight: 200,
};

function _getImageResolution(file) {
    return new Promise((resolve, reject) => {
        if (!(file instanceof File)) {
            reject(new Error('Input must be a File object'));
            return;
        }

        const reader = new FileReader();
        reader.onload = e => {
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = reject;
            img.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

const FJActionHeadshotGenerator = {
    //#region 初始化
    initPromptHeadshotAction: function () {
        return async dispatch => {
            const dataSet = await FJHeadshotUtil.loadHeadshotPromptData();
            dispatch(setHeadshotPromptDataSet(dataSet));
        };
    },

    //#endregion

    //#region UI 相关
    // 设置tab索引
    changeTabIndexAction: index => dispatch => {
        dispatch(setTabIndex(index));
    },

    // 设置当前收藏
    setCurrentCollectionAction: collection => dispatch => {
        dispatch(setCurrentCollection(collection));
    },
    // 重置头像生成状态
    resetHeadshotGeneratorState: () => dispatch => {
        dispatch(resetHeadshotGeneratorState());
    },

    // 设置当前状态
    setCurrentHeadshotStatus: status => dispatch => {
        dispatch(setCurrentHeadshotStatus(status));
    },

    // 设置当前步骤索引
    setCurrentStepIndexAction: stepIndex => dispatch => {
        // 设置当前步骤索引时，清空当前任务id
        dispatch(setCurrentTaskId(null));
        dispatch(setCurrentStepIndex(stepIndex));
    },

    // 上一步
    goPreviousStepAction: () => (dispatch, getState) => {
        const state = getState();
        const { currentStepIndex, maxSteps } = state.headshotGenerator;
        // 如果当前步骤是最后一步，则清空当前任务id
        if (currentStepIndex === maxSteps) {
            dispatch(setCurrentTaskId(null));
        }

        if (currentStepIndex > 0) {
            dispatch(setCurrentStepIndex(currentStepIndex - 1));
        }
    },

    // 下一步
    goNextStepAction: function () {
        return (dispatch, getState) => {
            const state = getState();
            const { currentStepIndex, maxSteps, selectedCategoryKey } = state.headshotGenerator;
            if (currentStepIndex === 0) {
                FJUtil.eaLog('ai_headshot_home_click', {
                    category: selectedCategoryKey,
                });
            }
            if (currentStepIndex < maxSteps) {
                dispatch(setCurrentStepIndex(currentStepIndex + 1));
            }
        };
    },

    // 动态步骤相关的方法, 重置默认值
    resetDefaultAction: function (gender = GENDER_OPTIONS.MALE) {
        return (dispatch, getState) => {
            const state = getState();
            const currentConfig = {
                profession: state.headshotGenerator.selectedProfession,
                hairPreferences: state.headshotGenerator.selectedHairPreferences,
                clothingPreference: state.headshotGenerator.selectedClothingPreference,
                backgroundPreference: state.headshotGenerator.selectedBackgroundPreference,
                theme: state.headshotGenerator.selectedTheme,
                ratio: state.headshotGenerator.selectedRatio,
                shot: state.headshotGenerator.selectedShot,
                gender: state.headshotGenerator.selectedGender,
            };

            const selectedCategoryKey = state.headshotGenerator.selectedCategoryKey;
            // 重置为新的性别默认值
            const newConfig = FJHeadshotUtil.resetToGenderDefaults(gender, selectedCategoryKey, currentConfig);

            dispatch(setSelectedGender(gender));
            dispatch(setSelectedProfession(newConfig.profession));
            dispatch(setSelectedHairPreferences(newConfig.hairPreferences));
            dispatch(setHairColorNewOption(null));
            dispatch(setSelectedClothingPreference(newConfig.clothingPreference));
            dispatch(setSelectedBackgroundPreference(newConfig.backgroundPreference));
            dispatch(setSelectedTheme(newConfig.theme));
            dispatch(setSelectedRatio(newConfig.ratio));
            dispatch(setSelectedShot(newConfig.shot));
            dispatch(setSelectedAge(newConfig.age));

            if (selectedCategoryKey === 'professional') {
                dispatch(setTotalOutput(20));
            } else {
                dispatch(setTotalOutput(newConfig.theme.length * 3));
            }
        };
    },

    // 设置分类
    setCategoryAction: function (category) {
        return dispatch => {
            dispatch(setSelectedCategory(category.value));
            dispatch(setSelectedCategoryKey(category.key));
            dispatch(setMaxSteps(DYNAMIC_STEPS_CONFIG[category.value].length - 1));
            dispatch(this.resetDefaultAction());
            dispatch(setOriginImage(null));
            dispatch(setImageInfo({}));
            dispatch(setImageUploadStatus(FJConstant.DEFAULT));
        };
    },

    setGenderAction: function (gender) {
        return dispatch => {
            dispatch(this.resetDefaultAction(gender));
            dispatch(setOriginImage(null));
            dispatch(setImageInfo({}));
            dispatch(setImageUploadStatus(FJConstant.DEFAULT));
            f_headshot_isUploading = false;
        };
    },

    setProfessionAction: profession => (dispatch, getState) => {
        const state = getState();
        const { selectedCategoryKey, selectedGender } = state.headshotGenerator;

        // 根据职业和分类获取第一个可用的主题
        const firstTheme = FJHeadshotUtil.getThemesByProfessionAndGender(
            profession,
            selectedCategoryKey,
            selectedGender,
        )[0];

        // 清空主题选择并设置默认值为第一个
        dispatch(setSelectedTheme([firstTheme]));
        dispatch(setSelectedProfession(profession));

        dispatch(setTotalOutput(3));
    },

    setHairPreferencesAction: hairPreferences => dispatch => {
        dispatch(setSelectedHairPreferences(hairPreferences));
    },

    setClothingPreferenceAction: clothingPreference => dispatch => {
        dispatch(setSelectedClothingPreference(clothingPreference));
    },

    setAgeAction: age => dispatch => {
        dispatch(setSelectedAge(age));
    },

    // 多选相关的方法
    toggleBackgroundPreferenceAction: backgroundPreference => (dispatch, getState) => {
        const state = getState();
        const currentPreferences = state.headshotGenerator.selectedBackgroundPreference;
        const newPreferences =
            currentPreferences.findIndex(p => p.value === backgroundPreference.value) !== -1
                ? currentPreferences.filter(p => p.value !== backgroundPreference.value)
                : [...currentPreferences, backgroundPreference];
        dispatch(setSelectedBackgroundPreference(newPreferences));
    },

    toggleThemeAction: theme => (dispatch, getState) => {
        const state = getState();
        const { selectedTheme } = state.headshotGenerator;
        const newThemes =
            selectedTheme.findIndex(t => t.key === theme.key) !== -1
                ? selectedTheme.filter(t => t.key !== theme.key)
                : [...selectedTheme, theme];
        dispatch(setSelectedTheme(newThemes));
        //  根据主题数量设置输出数量
        dispatch(setTotalOutput(newThemes.length * 3));
    },

    setRatioAction: ratio => dispatch => {
        dispatch(setSelectedRatio(ratio));
    },

    setShotAction: shot => dispatch => {
        dispatch(setSelectedShot(shot));
    },

    //#endregion

    //#region 图片处理相关

    /**
     * 检查图片格式和内容
     */
    recognizeImageAction: function (imageInfo) {
        return async (dispatch, getState) => {
            const state = getState();
            const { originImage } = state.headshotGenerator;
            try {
                f_headshot_isUploading = true;
                dispatch(setImageUploadStatus(FJConstant.UPLOADING));

                // 上传s3服务
                let imageUrl = imageInfo?.src;
                const file = await FJUtil.getBlobByUrl(imageUrl);
                const id = await FJUtil.hashEncode(imageUrl);
                const key = FJConfig.originalImageKey + `${id}.png`;
                const result = await FJImageStore.upLoadFileToS3Async(file, key);
                // 中途切换性别则跳过
                if (!f_headshot_isUploading) {
                    return;
                }
                if (result) {
                    imageUrl = FJS3Config.S3_SERVER_HOST + key;
                } else {
                    dispatch(setImageUploadStatus(FJConstant.ERROR));
                    return;
                }

                // 调用识别接口，校验图片是否合规
                const res = await FJNetworkStore.aiImageRecognition({ imageUrl });
                // 中途切换性别则跳过
                if (!f_headshot_isUploading) {
                    return;
                }
                // 不合规处理
                if (res.code === 200 && !res.data.isValid) {
                    dispatch(setImageUploadStatus(FJConstant.INVALID));
                } else if (res.code === 200 && res.data.isValid) {
                    dispatch(setImageUploadStatus(FJConstant.SUCCESS));
                    // 添加 race
                    dispatch(
                        setImageInfo({
                            ...imageInfo,
                            s3Url: imageUrl, // 替换为 s3 链接避免重复
                            race: res.data.race,
                        }),
                    );
                    FJUtil.eaLog('ai_headshot_upload', {
                        format: originImage.type,
                        size: (imageInfo.size / 1024 / 1024).toFixed(1),
                        resolution: Math.floor(imageInfo.width) + 'x' + Math.floor(imageInfo.height),
                    });
                } else {
                    dispatch(setImageUploadStatus(FJConstant.ERROR));
                }
            } catch (error) {
                dispatch(setImageUploadStatus(FJConstant.ERROR));
            }
            f_headshot_isUploading = false;
        };
    },

    /**
     * 设置图片信息，压缩图片，检查图片格式和内容
     * @param {File} file
     */
    setImageInfoAction: function (file, skipTranscoded = false) {
        return async dispatch => {
            // 1. 校验登陆状态
            const isLogin = FJUtil.isLogin();
            if (!isLogin) {
                dispatch(setImageUploadStatus(FJConstant.DEFAULT));
                FJUtil.login();
                return;
            }

            // 2. 检查图片格式
            const isImage = FJUtil.isImage(file, false, HEADSHOT_GENERATOR_UPLOAD_FILE_TYPE);
            if (!isImage) {
                if (skipTranscoded) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('upload-failed-please-upload-an-image-in-jpg-jpeg-png'),
                        'error',
                    );
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.setImageInfoAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('upload-failed-please-upload-an-image-in-jpg-jpeg-png'),
                            'error',
                        );
                    }
                    dispatch(setImageUploadStatus(FJConstant.DEFAULT));
                    return;
                }
            }

            const { width, height } = await _getImageResolution(file);
            // 3. 检测图片大小，不能超过限制 MAX_IMAGE_SIZE
            // if (file.size > MAX_IMAGE_SIZE * 1024 * 1024) {
            //     FJMessageStore.addMessage(
            //         FJLocalStore._('upload-failed-please-upload-an-image-between-xxx-kb-and-yyy-mb').replace(
            //             'xxx',
            //             MAX_IMAGE_SIZE,
            //         ),
            //         'error',
            //     );
            //     return;
            // }

            if (width < MIN_IMAGE_SIZE.minWidth || height < MIN_IMAGE_SIZE.minHeight) {
                FJMessageStore.addMessage(
                    FJLocalStore._('upload-failed-please-upload-an-image-larger-than-200px-x-200px'),
                    'error',
                );
                return;
            }

            // 4. 图片裁剪
            const processImage = async processedFile => {
                dispatch(setOriginImage(file));
                const imageUrl = await FJUtil.loadFileToUrl(processedFile.file);
                if (imageUrl) {
                    dispatch(setImageInfo({ src: imageUrl }));
                    // 5. Gemini 图片内容识别
                    dispatch(
                        this.recognizeImageAction({
                            src: imageUrl,
                            width: processedFile.width,
                            height: processedFile.height,
                            size: processedFile.file.size,
                        }),
                    );
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('upload-failed-please-try-again-later'), 'error');
                }
            };

            // 显示裁剪模态框，传入确认和取消回调
            dispatch(
                FJActionModal.showImageCropModalAction(
                    file,
                    // 确认回调：使用裁剪后的文件
                    croppedFile => {
                        processImage(croppedFile);
                    },
                    // 取消回调：清空状态，不继续处理
                    () => {
                        dispatch(setImageUploadStatus(FJConstant.DEFAULT));
                    },
                    {
                        inputType: 'file',
                        ...MIN_IMAGE_SIZE,
                    },
                ),
            );
        };
    },

    // 重新裁剪图片
    reCropImageAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { originImage } = state.headshotGenerator;

            const processImage = async processedFile => {
                const imageUrl = await FJUtil.loadFileToUrl(processedFile.file);
                if (imageUrl) {
                    dispatch(setImageInfo({ src: imageUrl }));
                    // 5. Gemini 图片内容识别
                    dispatch(
                        this.recognizeImageAction({
                            src: imageUrl,
                            width: processedFile.width,
                            height: processedFile.height,
                            size: processedFile.file.size,
                        }),
                    );
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('upload-failed-please-try-again-later'), 'error');
                }
            };

            // 显示裁剪模态框，传入确认和取消回调
            dispatch(
                FJActionModal.showImageCropModalAction(
                    originImage,
                    // 确认回调：使用裁剪后的文件
                    croppedFile => {
                        processImage(croppedFile);
                    },
                    // 取消回调
                    () => {
                        // dispatch(setImageUploadStatus(FJConstant.DEFAULT));
                    },
                    {
                        inputType: 'file',
                        ...MIN_IMAGE_SIZE,
                    },
                ),
            );
        };
    },

    deleteImageInfoAction: () => {
        return async dispatch => {
            dispatch(setImageInfo({}));
            dispatch(setImageUploadStatus(FJConstant.IDLE));
        };
    },

    //#endregion

    //#region 生成

    /**
     * 生成头像
     */
    onGenerationAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { creditNumber, canFreeCreate } = state.common;
            const {
                imageInfo,
                selectedCategoryKey,
                totalOutput,
                unitPrice,
                selectedGender,
                currentStepIndex,
                selectedShot,
                selectedRatio,
                selectedHairPreferences,
                selectedClothingPreference,
                selectedBackgroundPreference,
                headshotPromptDataSet,
                imageUploadStatus,
                selectedTheme,
                selectedAge,
            } = state.headshotGenerator;

            dispatch(setSliceTaskStatusAction(FJConstant.START));
            const totalPrice = totalOutput * unitPrice ?? 30;

            if (selectedCategoryKey === 'professional') {
                FJUtil.eaLog('ai_headshot_professional_selects', {
                    hairstyle: selectedHairPreferences?.style,
                    clothes: selectedClothingPreference?.value,
                    background: selectedBackgroundPreference?.map(item => item.value).join(','),
                    shot: selectedShot.value,
                    ratio: selectedRatio.value,
                });
            } else {
                FJUtil.eaLog('ai_headshot_others_styles_selects', {
                    name: selectedTheme.map(item => item.key).join(','),
                });

                FJUtil.eaLog('ai_headshot_generate_click_styles_amount', { amount: selectedTheme.length });
            }

            if (selectedGender === GENDER_OPTIONS.MALE) {
                FJUtil.eaLog('ai_headshot_male_gender_select', { category: selectedCategoryKey });
            } else {
                FJUtil.eaLog('ai_headshot_female_gender_select', { category: selectedCategoryKey });
            }

            FJUtil.eaLog('ai_headshot_generate_click', { category: selectedCategoryKey });

            // 0. 生成提示词
            if (!imageInfo?.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            if (imageUploadStatus !== FJConstant.SUCCESS) {
                FJMessageStore.addMessage(FJLocalStore._('image-not-compliant'), 'error');
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            let prompts = [];
            const { race } = imageInfo;
            try {
                // 检查dataSet 是否存在和充足，否则重新fetch一次
                if (!headshotPromptDataSet || Object.keys(headshotPromptDataSet).length === 0) {
                    await dispatch(this.initPromptHeadshotAction());
                }
                prompts = await FJHeadshotUtil.generateHeadshotPrompt({
                    gender: selectedGender,
                    race,
                    category: selectedCategoryKey,
                    shot: selectedShot.value,
                    hairColor: selectedHairPreferences?.color.value,
                    hairStyle: selectedHairPreferences?.style,
                    clothes: selectedClothingPreference?.value,
                    background: selectedBackgroundPreference?.map(item => item.value),
                    theme: selectedTheme,
                    dataSet: headshotPromptDataSet,
                    age: selectedAge?.value,
                });
            } catch (error) {
                console.log('Generating prompts error: ', error);
                FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
                dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
                return;
            }

            const { width, height } = RATIO_OPTIONS.find(item => item.key === selectedRatio.key);

            // 1. user space 检查
            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                },
            });

            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            // 2. 额度检查
            if (creditNumber < totalPrice && !canFreeCreate) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            // 3. 上传图片到s3
            let imageUrl = imageInfo?.s3Url; // 识别接口已经上传到s3
            if (!imageUrl) {
                // 没有上传到s3，则上传
                imageUrl = imageInfo?.src;
                try {
                    const file = await FJUtil.getBlobByUrl(imageUrl);
                    const id = await FJUtil.hashEncode(imageUrl);
                    const key = FJConfig.originalImageKey + `${id}.png`;
                    const result = await FJImageStore.upLoadFileToS3Async(file, key);
                    if (result) {
                        imageUrl = FJS3Config.S3_SERVER_HOST + key;
                    } else {
                        dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
                        return;
                    }
                } catch (error) {
                    dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
                    return;
                }
            }

            // 4. 调用生成接口，生成头像
            const _request = async () => {
                const params = {
                    img_url: imageUrl,
                    prompt: prompts,
                    height,
                    width,
                    name: FJLocalStore._(selectedCategoryKey),
                    category: selectedCategoryKey,
                };

                const res = await FJNetworkStore.aiGenerateAvator(params);
                return res;
            };

            try {
                const eventId = await FJActionCommon.createRequestTask(_request, dispatch);
                if (!eventId) {
                    dispatch(this.generateErrorAction(true));
                    return;
                }
                FJUtil.eaLog('ai tool start generating', { 'credit&free': 'credit', tool: FJUtil.getToolName() });
                dispatch(setCurrentTaskId(eventId));
                FJUtil.updateAllCreditInfo(false);
                dispatch(FJActionCommon.updateHistoryListAction());

                dispatch(setCurrentStepIndex(currentStepIndex + 1));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            } catch (error) {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(setCurrentTaskId(null));
            }
        };
    },

    /**
     * 检查是否有正在生成的任务，如果存在继续轮询
     * @param {*} ids
     * @param {*} callback
     * @param {*} options
     * @returns
     */
    checkIsShowGeneratingHeadshotNumAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { historyList } = state.common;
            const generatingTaskIdList = historyList
                // 包含progress和queued状态
                .filter(item => item.status === 'processing' || item.status === 'queued')
                .map(item => item.eventId);
            const generatingHeadshotNum = generatingTaskIdList.length;

            dispatch(setGeneratingHeadshotNum(generatingHeadshotNum));
            if (!f_headshot_isPolling) {
                dispatch(this.pollingHeadshotTaskAction());
            }

            if (generatingHeadshotNum > 0) {
                // 生成中计数常显
                dispatch(setIsShowGeneratingHeadshotNum(true));
            } else {
                dispatch(setIsShowGeneratingHeadshotNum(false));
            }

            // 检查是否有正在预览的合集, 则更新当前合集
            const { currentCollection } = state.headshotGenerator;
            if (currentCollection) {
                const newCollection = historyList.find(item => item.id === currentCollection.id);
                if (newCollection) {
                    dispatch(setCurrentCollection(newCollection));
                }
            }
        };
    },

    pollingHeadshotTaskAction: function () {
        return async (dispatch, getState) => {
            f_headshot_isPolling = true;
            const _clear = () => {
                f_headshot_isPolling = false;
                if (f_headshot_timer) {
                    clearTimeout(f_headshot_timer);
                    f_headshot_timer = null;
                }
            };
            _clear();

            const state = getState();
            const { tabIndex, currentTaskId, currentStepIndex, selectedCategory } = state.headshotGenerator;
            const { historyList } = state.common;
            const generatingTaskIdList = historyList
                // 包含progress和queued状态
                .filter(item => item.status === 'processing' || item.status === 'queued')
                .map(item => item.eventId);

            if (generatingTaskIdList.length === 0) {
                _clear();
                return;
            }

            const delayTime = TASK_POLLING_INTERVAL * 10;
            const __pollingFunc = () => {
                dispatch(this.pollingHeadshotTaskAction());
            };

            try {
                const result = await FJNetworkStore.getTaskState(generatingTaskIdList.join(','));
                let isStopPolling = false;
                let data = result;

                if (!data) {
                    f_headshot_errorTime++;
                    if (f_headshot_errorTime >= MAX_POLLING_ERROR_TIME) {
                        _clear();
                    } else {
                        _clear();
                        f_headshot_isPolling = true;
                        f_headshot_timer = setTimeout(__pollingFunc, delayTime);
                    }
                    return;
                }

                if (!Array.isArray(result)) {
                    // 处理数组类型的data
                    data = [result];
                }

                let failTaskCount = 0;
                let isNeedUpdate = false;
                let successId = null;
                await Promise.all(
                    data.map(async item => {
                        switch (item.job_state) {
                            case 'succeeded':
                                FJUtil.eaLog('ai tool generate success', {
                                    'credit&free': 'credit',
                                    tool: FJUtil.getToolName(),
                                });
                                isNeedUpdate = true;
                                successId = item.event_id;
                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                break;
                            case 'timeout':
                            case 'failed':
                                isNeedUpdate = true;
                                failTaskCount++;
                                if (failTaskCount === generatingTaskIdList.length) {
                                    isStopPolling = true;
                                }

                                break;
                            default:
                                break;
                        }
                    }),
                );
                if (isStopPolling) {
                    _clear();
                } else {
                    _clear();
                    f_headshot_isPolling = true;
                    f_headshot_timer = setTimeout(__pollingFunc, delayTime);
                }
                if (isNeedUpdate) {
                    // 生成成功时，如果在最后一步（生成中） 跳转到历史页面
                    const steps = DYNAMIC_STEPS_CONFIG[selectedCategory];
                    if (tabIndex === 0 && currentStepIndex === steps.length - 1) {
                        dispatch(this.changeTabIndexAction(1));
                    }
                    if (currentTaskId && successId === currentTaskId) {
                        dispatch(setCurrentTaskId(null));
                        dispatch(setCurrentStepIndex(0));
                    }
                    dispatch(
                        FJActionCommon.updateHistoryListAction(
                            newHistoryList => {
                                const generatingHeadshot = newHistoryList.find(item => item.id === successId);

                                FJUtil.eaLog('ai_headshot_generate_success', {
                                    category: generatingHeadshot?.category,
                                    amount: generatingHeadshot?.headshotList?.filter(item => !!item.result).length || 0,
                                });
                            },
                            { ignoreLoading: true },
                        ),
                    );
                    FJUtil.updateAllCreditInfo(false);
                }
            } catch (error) {
                _clear();
                f_headshot_isPolling = false;
            }
        };
    },

    // 删除头像
    onDeleteHeadshotAction: (ids, callback, options) => {
        return async (dispatch, getState) => {
            const state = getState();
            const { headshotIds } = options;
            const { historyList } = state.common;

            let deleteHistoryList = historyList.filter(item => ids.includes(item.id));

            let _tempList = [];
            deleteHistoryList.map(item => {
                // 如果 headshotIds 不为空，则过滤 headshotList, 否则默认下载全部 headshotList images
                if (headshotIds?.length > 0) {
                    const headshotList = item.headshotList.filter(item => headshotIds.includes(item.id));
                    _tempList.push(...(headshotList.length > 0 ? headshotList : []));
                } else {
                    _tempList.push(...item.headshotList);
                }
                return item;
            });
            deleteHistoryList = _tempList.map(item => item.id);

            try {
                const result = await FJNetworkStore.deleteTaskList(deleteHistoryList);
                const { code } = result;
                if (code === 200) {
                    dispatch(FJActionCommon.updateHistoryListAction(callback));
                } else if (code === 214) {
                    FJUtil.login();
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                }
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
            }
        };
    },

    // 下载当前合集内的部分头像
    onDownloadHeadshotAction: (ids, callback) => {
        return async (dispatch, getState) => {
            const state = getState();
            const { currentCollection } = state.headshotGenerator;
            dispatch(
                FJActionCommon.multiDownloadAction(currentCollection.id, 'multiple choose', callback, {
                    headshotIds: ids,
                }),
            );
        };
    },

    // 下载多个合集的全部头像
    onDownloadCollectionAction: (collectionIds, callback) => {
        return async dispatch => {
            dispatch(FJActionCommon.multiDownloadAction(collectionIds, 'multiple choose', callback));
        };
    },

    // 重试， 重新生成单个头像任务 （不是整个合集）
    onRetryHeadshotAction: (eventId, itemId) => {
        return async (dispatch, getState) => {
            const state = getState();
            const { historyList } = state.common;
            const historyItem = historyList.find(item => item.id === eventId);
            if (historyItem) {
                const headshotItem = historyItem.headshotList.find(item => item.id === itemId);
                if (headshotItem) {
                    const { eventId, id, width, height, prompt, originalUrl, is_grayscale } = headshotItem;
                    // 积极UI
                    dispatch(
                        setCurrentCollection({
                            ...historyItem,
                            headshotList: historyItem.headshotList.map(item => {
                                if (item.id === itemId) {
                                    return { ...item, status: 'processing' };
                                }
                                return item;
                            }),
                        }),
                    );

                    try {
                        const request = async () => {
                            const params = {
                                id,
                                event_id: eventId,
                                img_url: originalUrl,
                                prompt: {
                                    value: prompt,
                                    is_grayscale,
                                },
                                height,
                                width,
                            };
                            const res = await FJNetworkStore.aiRetryGenerateAvator(params);
                            return res;
                        };

                        const newEventId = await FJActionCommon.createRequestTask(request, dispatch);
                        if (newEventId) {
                            dispatch(
                                FJActionCommon.updateHistoryListAction(newHistoryList => {
                                    const newCollection = newHistoryList.find(item => {
                                        return item.id === eventId;
                                    });
                                    newCollection && dispatch(setCurrentCollection(newCollection));
                                }),
                            );

                            dispatch(
                                FJActionCommon.pollingTaskAction([newEventId], {
                                    callback: () => {},
                                    cusUpdateTaskStatus: () => {},
                                    cusUpdateCreationList: () => {},
                                }),
                            );
                        }
                    } catch (error) {
                        console.log('Retry headshot task error: ', error);
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
                    }
                    FJUtil.updateAllCreditInfo(false);
                }
            }
        };
    },

    //#endregion
};

export default FJActionHeadshotGenerator;
